import { BannerId } from './banners';
import { CampaignId, CampaignType, ImageSize } from './domain';
import { GroupId } from './groups';

export interface ImportWizardState {
    phase: ImportWizardPhase;
    importMode: ImportWizardUploadMode;
    importData?: ImportWizardData;
    importFile?: ImportWizardFile;
    errors?: string[];
}

export interface ImportWizardData {
    campaign: {
        id: CampaignId;
        name: string;
        type: CampaignType;
    };
    adsCount?: number;
    ads?: ImportDataAds[];
    groups?: ImportDataGroups[];
}

export interface ImportWizardFile {
    file: File;
    name: string;
    mdsGroupId: string;
}

export type ImportWizardBannerImage = ImportWizardBannerUploadedImage[] | ImportWizardBannerRequiresImage;

export interface ImportDataAds {
    id: BannerId | null;
    description: string;
    groupId: GroupId | null;
    groupName: string;
    images: ImportWizardBannerImage[];
}

export interface ImportDataGroups {
    id: GroupId | null;
    name: string;
}

export interface ImportWizardBannerRequiresImage {
    name: string;
    needUpload: true;
}

export interface ImportWizardBannerUploadedImage extends ImageSize {
    imageHash: string;
    mdsGroupId: string;
    namespace: string;
    needUpload: false;
}

export interface ImportWizardDataRaw {
    uploadedFileInfo: {
        fileName: string;
        group: number;
    };
    campaignId: CampaignId;
    campaignName: string;
    campaignType: CampaignType;
    ads?: ImportWizardAdsDataRaw[];
    adsCount?: number;
    adGroups?: ImportWizardGroupsDataRaw[];
}

export interface ImportWizardGroupsDataRaw {
    id: GroupId;
    name: string;
}

export interface ImportWizardAdsDataRaw {
    id: BannerId;
    description: string;
    adGroupId: GroupId;
    adGroupName: string;
    images: ImportWizardBannerImage[];
}

export enum ImportWizardPhase {
    FILE_UPLOAD = 'FILE_UPLOAD',
    IMAGE_UPLOAD = 'IMAGE_UPLOAD',
    VALIDATION = 'VALIDATION'
}

export enum ImportWizardUploadMode {
    ONLY_AD_GROUPS = 'ONLY_AD_GROUPS',
    ONLY_ADS = 'ONLY_ADS',
    AD_GROUPS_WITH_ADS = 'AD_GROUPS_WITH_ADS'
}
